// extracted by mini-css-extract-plugin
export default {"form":"styles-scoped__form--veuDj","fields":"styles-scoped__fields--l9v82","error":"styles-scoped__error--F4l0m","actions":"styles-scoped__actions--CqbKo"};